import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { ref } from "vue";

export default function useHistoryLog(maxHistory: number) {
  const currentItem = ref<string | undefined>();
  let currentItemNoHistory = false;
  const currentItemIcon = ref<IconDefinition | undefined>();
  const historyItems = ref<Array<{ index: number; value: string; icon: IconDefinition }>>([]);
  let currentIdx = 0;

  /**
   * Update the current history log item. Moves the current item (if any) to the history if it changed, optionally with a predefined icon
   * set using `setFutureIcon`.
   * @param item The item (string) to push
   * @param noHistory Do not add this item to the history once it gets moved
   * @param currentIcon Icon for this entry as long as it's the current one
   * @param historyIcon Icon for this entry as soon as the current entry is moved to the history
   */
  function updateItem(item: string, noHistory?: boolean, currentIcon?: IconDefinition, historyIcon?: IconDefinition) {
    if (item === currentItem.value) return;
    console.debug(
      `Pushing history log entry: ${item}, do not add to history: ${noHistory}, current icon: ${currentIcon}`,
    );
    if (currentItem.value && !currentItemNoHistory) {
      const icon = historyIcon ?? faCheck;
      historyItems.value.push({ index: currentIdx, value: currentItem.value, icon });
      currentIdx += 1;
      if (historyItems.value.length > maxHistory) {
        historyItems.value.shift();
      }
    }
    currentItem.value = item;
    currentItemNoHistory = !!noHistory;
    currentItemIcon.value = currentIcon;
  }

  return { currentItem, currentItemIcon, historyItems, updateItem };
}
